import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Ravenhold gave my illustrations a home where darkness is celebrated, not censored. The Thornmarket changed everything for my art career.',
  author: 'Isolde Varnhem',
  role: 'Gothic Illustrator'
}, {
  quote: 'I found my composer through Vesper Circle. Our horror short film scored three festival selections. This community is real.',
  author: 'Caius Drenthe',
  role: 'Horror Filmmaker'
}, {
  quote: 'The Obsidian Archive is a treasure vault. I have discovered more inspiring dark fiction here in two months than in years of searching elsewhere.',
  author: 'Seraphine Morrowe',
  role: 'Dark Fantasy Author'
}];
export function TestimonialsSection() {
  return <section className="py-24 bg-charcoal relative overflow-hidden" data-id="element-142">
      {/* Decorative Rose Background */}
      <div className="absolute top-0 left-0 w-64 h-64 opacity-5 pointer-events-none" data-id="element-143">
        <svg viewBox="0 0 100 100" fill="currentColor" className="text-crimson w-full h-full" data-id="element-144">
          <path d="M50 0C22.4 0 0 22.4 0 50s22.4 50 50 50 50-22.4 50-50S77.6 0 50 0zm0 90c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z" data-id="element-145" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-146">
        <div className="text-center mb-16" data-id="element-147">
          <h2 className="font-heading text-3xl md:text-4xl text-parchment mb-4" data-id="element-148">
            Whispers from the Circle
          </h2>
          <div className="flex justify-center gap-2" data-id="element-149">
            <div className="w-2 h-2 rounded-full bg-crimson/50" data-id="element-150" />
            <div className="w-2 h-2 rounded-full bg-crimson/50" data-id="element-151" />
            <div className="w-2 h-2 rounded-full bg-crimson/50" data-id="element-152" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-153">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.5
        }} className="bg-obsidian p-8 border border-white/5 relative group hover:border-crimson/30 transition-colors duration-500" data-id="element-154">
              <Quote className="w-8 h-8 text-charcoal absolute top-6 right-6 group-hover:text-crimson/20 transition-colors duration-500" data-id="element-155" />

              <p className="font-body text-lg text-bone/90 italic mb-8 leading-relaxed relative z-10" data-id="element-156">
                "{item.quote}"
              </p>

              <div className="border-t border-white/5 pt-6" data-id="element-157">
                <h4 className="font-heading text-lg text-parchment font-semibold" data-id="element-158">
                  {item.author}
                </h4>
                <p className="font-body text-sm text-amber-dim" data-id="element-159">{item.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}